//#region Imports

import chroma from 'chroma-js';

//#endregion

function adjust(color: number, amount: number): number {
    return Math.min(255, Math.max(0, color + amount));
}

/**
 * @public
 */
export function darken(hex: string, factor: number): string {
    const [r, g, b] = chroma(hex).rgb()
        .map(x => adjust(x, -factor));
    return chroma(r, g, b, 'rgb').hex();
}

/**
 * @public
 */
export function lighten(hex: string, factor: number): string {
    const [r, g, b] = chroma(hex).rgb()
        .map(x => adjust(x, factor));
    return chroma(r, g, b, 'rgb').hex();
}
